import React from 'react'
import RichText from '../../../../../general/rich-text/RichText'



const ShareIntro = ({data}) => {
    return (
        <div className='share-intro'>
            <div 
                className="elevate text"
            >
                <RichText>{data.homePageShareIntroHeading}</RichText>
                <RichText>{data.homePageShareIntroBody}</RichText>
            </div>

            <style jsx>{`
                .share-intro {
                    position: relative;
                    padding: 35px 0px;
                    padding-bottom: 0;
                }

                .share-intro .text {
                    max-width: 650px;
                    margin: 0 auto;
                    padding: 50px 30px 50px;
                    text-align: center;
                    padding-bottom: 20px;
                }

                img {
                    width: 600px;
                }
                
                .share-intro :global(p) {
                    margin: 20px 0;
                }
            `}</style>
        </div>
    )
}


export default ShareIntro